import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

const componentTypeOptions = [
  { label: 'Adjustment Factor (AF)', value: 'Adjustment Factor (AF)' },
  { label: 'Additional Item (AI)', value: 'Additional Item (AI)' },
  { label: 'Construction Material (CM)', value: 'Construction Material (CM)' },
];

function BuildingComponentModal({
  history,
  getBuildingComponentTypeList,
  getSingleComponentType,
  type,
  createBuildComponentType,
  updateBuildComponentType,
  updateList,
  id,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId,
}) {

  const [formData, setFormData] = useState({
    name: '',
    type: '',
    code: '',
    rate_1: '',
    rate_2: '',
    is_percent: 0,
    is_active: 0,
    ordinance_revision_id: ordinanceRevisionId,

  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    type: 'required',
    code: 'required',
    rate_1: 'required',
    rate_2: 'required',
    ordinance_revision_id: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const handleOnChangeSelect = (key, label) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
      [label]: e.label,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (type === 'NEW') {
      createBuildComponentType(formData, (data) => {
        setModal({ isOpen: false });
        history.push(`/rpt/building/settings/building-components/${data.data.id}`);
        getBuildingComponentTypeList();
        getSingleComponentType(data.data.id)
      });
    }

    if (type === 'EDIT') {
      updateBuildComponentType(id, formData, (data) => {
        setModal({ isOpen: false });
        history.push(`/rpt/building/settings/building-components/${data.data.id}`);
        getBuildingComponentTypeList();
        getSingleComponentType(data.data.id)
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);
  const onSetFormData = () => {
    setFormData({
      name: _.get(updateList, 'name') || '',
      type: _.get(updateList, 'type') || '',
      code: _.get(updateList, 'code') || '',
      rate_1: _.get(updateList, 'rate_1') || '',
      rate_2: _.get(updateList, 'rate_2') || '',
      is_percent: _.get(updateList, 'is_percent') || 0,
      is_active: _.get(updateList, 'is_active') || 0,
      ordinance_revision_id: _.get(updateList, 'ordinance_revision_id') || ''
    });
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, []);

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Name/Description {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="text-muted">
              Type {validateForm.renderMessage('type')}
            </label>
            <Select
              value={
                componentTypeOptions.find(
                  (item) => _.get(formData, 'type') === _.get(item, 'value')
                ) || ''
              }
              onChange={handleOnChangeSelect('type')}
              options={componentTypeOptions}
              placeholder="Select Type"
              components={{
                IndicatorSeparator: () => null,
              }}
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Rate 1 {validateForm.renderMessage('rate_1')}
            </label>
            <input
              className="form-control"
              type="number"
              name="rate_1"
              onChange={onChange}
              value={_.get(formData, 'rate_1')}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Rate 2 {validateForm.renderMessage('rate_2')}
            </label>
            <input
              className="form-control"
              type="number"
              name="rate_2"
              onChange={onChange}
              value={_.get(formData, 'rate_2')}
            />
          </div>
          <div className='col-12 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              isDisabled
              options={createDropdown(ordinanceRevisionList)}
              styles={customStyle}
              placeholder="Select Ordinance"
              value={
                createDropdown(ordinanceRevisionList).filter(
                  (item) =>
                    +_.get(formData, 'ordinance_revision_id') ===
                    +_.get(item, 'value')
                ) || ''
              }
              onChange={(e) => {
                handleOrdinanceSelect(e);
              }}
              formatOptionLabel={onRenderOption}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Percent: &nbsp;
            </label>
            <input
              name="is_percent"
              type="checkbox"
              checked={_.get(formData, 'is_percent')}
              onChange={onChange}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BuildingComponentModal.defaultProps = {
  type: '',
  updateList: {},
  id: '',
  ordinanceRevisionId: '',
};

BuildingComponentModal.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  ordinanceRevisionId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  createBuildComponentType: PropTypes.instanceOf(Function).isRequired,
  updateBuildComponentType: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBuildingComponentTypeList: PropTypes.instanceOf(Function).isRequired,
  getSingleComponentType: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BuildingComponentModal);
